import { Flex, Icon, Text } from "@chakra-ui/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import Link from "next/link";
import type { AnnouncementQuery } from "~/__generated__/graphql";

type AnnouncementProps = {
  data: AnnouncementQuery["announcement"];
};
const Announcement = ({ data }: AnnouncementProps) => {
  if (!data?.data) return null;
  return (
    <Flex
      justify={"center"}
      align={"center"}
      bgColor={"#0D3050"}
      gap="4px"
      color="white"
      fontFamily={"'Inter', sans-serif"}
      py={{ lg: "16px", base: "12px" }}
      px={{ lg: "unset", base: "50px" }}
    >
      <Text
        as={Link}
        href={data.data?.attributes?.redirectURL}
        fontSize={{ lg: "20px", base: "12px" }}
        lineHeight={{ lg: "20px", base: "16px" }}
        cursor={"pointer"}
        textAlign={"left"}
        borderBottom="2px solid transparent"
        _hover={{
          borderBottom: "2px solid white",
        }}
      >
        <Text as="span" pr="4px">
          {data?.data?.attributes?.content}
        </Text>

        <Icon
          as={ArrowRightIcon}
          width={{ lg: "20px", base: "14px" }}
          height={{ lg: "20px", base: "14px" }}
          mb="-3px"
        />
      </Text>
    </Flex>
  );
};

export default Announcement;
